<template>
    <div>
        <div class="row">
            <div class="col-12 mb-3">
                <div class="d-flex justify-content-end">
                    <app-button 
                        :label="$t('add_contact_customer')" 
                        class-name="btn-primary mr-2 mt-2" 
                        :is-disabled="false"
                        @submit="openEditModal()" 
                    />
                </div>
            </div>

            <div class="col-12 col-sm-6 col-xl-3 mb-3 p-2 " v-for="(item, index) in contactsData" :key="index">
                <div class="card w-80 h-100">
                    <h5 class="card-header">{{ item.name }}</h5>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-9">
                                <p class="card-text"><b>{{ $t('contact_name') }}: </b>{{ item.name }}</p>
                                <p class="card-text"><b>{{ $t('phone') }}: </b>{{ item.Phone }}</p>
                                <p class="card-text"><b>{{ $t('fax') }}: </b>{{ item.Fax }}</p>
                                <p class="card-text"><b>{{ $t('email') }}: </b>{{ item.Email }}</p>
                                <p class="card-text"><b>{{ $t('position') }}: </b>{{ item.Position }}</p>
                            </div>
                            <div class="col-3 d-flex align-items-center justify-content-center">
                                <div class="icon-wrapper">
                                    <app-icon name="users" />
                                </div>
                            </div>
                        </div>
                        <div class="row d-flex justify-content-between">
                            <app-button 
                                :label="$t('edit_contact_customer')" 
                                class-name="btn-primary mr-2 mt-2" 
                                :is-disabled="false"
                                @submit="openEditModal(item)" 
                            />
                            <!-- <app-button 
                                :label="$t('delete')" 
                                class-name="btn-danger mr-2 mt-2" 
                                :is-disabled="false"
                                @submit="openDeleteModal(item)" 
                            /> -->
                        </div>
                    </div>
                </div>
            </div>
            <modal-contacts v-if="modalEdit" :dataContact="dataContact" :selectedUrl="selectedUrl" :company_id="company_id" @contact-updated="handleContactUpdated" @close-modal-contacts="closeModal" />
            <app-delete-modal v-if="deleteConfirmationModalActive" :preloader="deleteLoader" modal-id="demo-delete"
                        @confirmed="confirmed" @cancelled="cancelled" />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl.js";
import ModalContacts from './../Crud/ModalContacts.vue';

export default {
    name: "AddProductModal",
    extends: CoreLibrary,
    components: {
        ModalContacts
    },
    data() {
        return {
            preloader: false,
            contactsData: [],
            company_id: 0,
            contact_id : null,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            inputs: {
                name: '',
                postal_zip_code: '',
                ext: '',
                email: '',
                phone: '',
                address: '',
                country: { id: null, name: null },
                state: { id: null, name: null },
                city: { id: null, name: null },
            },
            modalEdit: false,
            dataContact: {},
            selectedUrl: '',
            watchActive: false // bandera para controlar el watch
        }
    },

    methods: {
        openEditModal(item) {
            if (!item) {
                let companiesDta = localStorage.getItem('DataCustomersEdit');
                companiesDta = JSON.parse(companiesDta);
                this.company_id = companiesDta.id
                this.modalEdit = true;
                this.selectedUrl = '';
            } else {
                this.company_id = 0;
                this.dataContact = item;
                this.selectedUrl = `${actions.COMPANIESCONTACT}/${item.id}`
                this.modalEdit = true;
            }
        },

        handleContactUpdated(updatedContact) { 
            const existingIndex = this.contactsData.findIndex(contact => contact.id === updatedContact.id);
            if (existingIndex !== -1) {
                this.$set(this.contactsData, existingIndex, updatedContact);
            } else {
                this.contactsData.push(updatedContact);
            }
        },

        closeModal(){
            this.modalEdit = false
            this.dataContact = {}
        },

        confirmed() {
            let url = `company-contacts/${this.contact_id}`;    
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#demo-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                    const base_url = localStorage.getItem("base_url");
                    window.location.href = `${base_url}/companies/list`;
                }).catch(({ error }) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },

        openDeleteModal(item) {
            this.contact_id = item.id;
            this.deleteConfirmationModalActive = true;
        },

        reSetData() {
            this.selectedUrl = '';
        },
    },

    watch: {
        inputs: {
            deep: true, // Para detectar cambios profundos en el objeto
            handler(newVal) {
                // Guardamos los inputs en localStorage
                localStorage.setItem('DataCustomersContacts', JSON.stringify(newVal));
            }
        }
    },

    created() {
        const savedInputs = localStorage.getItem('DataCustomersContacts');
        if (savedInputs) {
            this.contactsData = JSON.parse(savedInputs);
        }
    }
}
</script>
